:root {
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #122033;
  background: #f5f7fb;
}

* { box-sizing: border-box; }
body { margin: 0; background: #f5f7fb; }
button, input { font: inherit; }
button { border: 1px solid #cbd4e4; background: #fff; border-radius: 8px; min-height: 38px; padding: 0 14px; cursor: pointer; }
.shell { display: grid; grid-template-columns: 272px minmax(0, 1fr); min-height: 100vh; }
aside { background: #111827; color: #e5ecfb; padding: 22px 16px; display: grid; align-content: start; gap: 7px; }
.brand { font-size: 19px; font-weight: 800; padding: 8px 10px 18px; }
aside button { display: flex; align-items: center; gap: 10px; border: 0; background: transparent; color: #cbd5e1; justify-content: flex-start; }
aside button.active, aside button:hover { background: rgba(255,255,255,.1); color: #fff; }
main { padding: 26px; min-width: 0; }
header { display: flex; justify-content: space-between; gap: 18px; align-items: center; margin-bottom: 22px; }
h1, h2 { margin: 0; letter-spacing: 0; }
h1 { font-size: 28px; }
h2 { font-size: 18px; margin-bottom: 14px; }
.cards { display: grid; grid-template-columns: repeat(4, minmax(0, 1fr)); gap: 14px; }
.card, .panel, .login form, .drawer { background: #fff; border: 1px solid #dfe6f2; border-radius: 8px; box-shadow: 0 10px 28px rgba(16,32,51,.05); }
.card { padding: 18px; min-height: 108px; display: flex; flex-direction: column; justify-content: space-between; }
.card span, .muted { color: #64748b; }
.card strong { font-size: 27px; }
.panel { padding: 18px; margin-bottom: 18px; overflow: hidden; }
.tableWrap { overflow-x: auto; }
table { width: 100%; border-collapse: collapse; min-width: 780px; }
th, td { padding: 11px 13px; border-bottom: 1px solid #edf2f8; text-align: left; font-size: 13px; vertical-align: top; }
th { background: #f8fafc; color: #526074; }
tr.clickable { cursor: pointer; }
tr.clickable:hover { background: #f7fbff; }
.empty, .center { padding: 42px; text-align: center; color: #64748b; }
.error { color: #8a1f1f; }
.login { min-height: 100vh; display: grid; place-items: center; padding: 24px; }
.login form { width: min(420px, 100%); padding: 28px; display: grid; gap: 14px; }
.login label { display: grid; gap: 6px; color: #526074; font-weight: 700; }
.login input { min-height: 42px; border: 1px solid #cbd4e4; border-radius: 8px; padding: 0 10px; }
.logo { width: 52px; height: 52px; border-radius: 12px; display: grid; place-items: center; background: linear-gradient(135deg,#635bff,#3fd28b); color: #fff; font-weight: 800; }
.drawer { position: fixed; right: 0; top: 0; width: min(620px,100vw); height: 100vh; overflow-y: auto; padding: 20px; z-index: 5; }
.drawerHead { display: flex; justify-content: space-between; gap: 14px; margin-bottom: 18px; }
pre { max-height: 260px; overflow: auto; background: #f8fafc; border: 1px solid #e2e8f0; border-radius: 8px; padding: 12px; font-size: 12px; }
@media (max-width: 920px) {
  .shell { grid-template-columns: 1fr; }
  aside { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .brand { grid-column: 1 / -1; }
  .cards { grid-template-columns: 1fr; }
  main { padding: 16px; }
}

